import {
  PAYMENT_METHOD_SESSION_STORAGE_ENTRY,
  PaymentMethod,
  SUPPORTED_PAYMENT_TYPES,
} from 'utils/constants';

export const addPaymentToSessionStorage = ({
  orderNoEntryName,
  paymentMethod,
  orderNo,
}: {
  orderNoEntryName?: PAYMENT_METHOD_SESSION_STORAGE_ENTRY;
  orderNo: string;
  paymentMethod:
    | (typeof PaymentMethod)[keyof typeof PaymentMethod]
    | SUPPORTED_PAYMENT_TYPES;
}) => {
  try {
    if (orderNoEntryName && orderNo) {
      window.sessionStorage.setItem(orderNoEntryName, orderNo);
    }
    window.sessionStorage.setItem('payment-method', paymentMethod);
  } catch {}
};
